import { AiOutlineLoading3Quarters } from '@react-icons/all-files/ai/AiOutlineLoading3Quarters';
import styled, { keyframes } from 'styled-components';
const rotate = keyframes `
  100% {
    transform:rotate(360deg);
  }
`;
export const S = {
    Layout: styled(AiOutlineLoading3Quarters) `
    animation: ${rotate} 1s linear infinite;
  `,
};
